import type { AllRouteEndpoints } from "../routeTypes";

export const aiAgentOpenaiResponsesAppGroupId = "/ai_agent/openai_responses/:app_group_id";

export const aiAgentOpenaiResponsesAppGroupIdCacheKeys: AllRouteEndpoints[] = [];
